module.exports = __webpack_public_path__ + "static/font-c72f8f4dbdd364db92693fe4c4aeddd8.ttf";